import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { AuthTokenResponse, useGetTokenQueryKey } from './type';

export const requireRefreshedToken = async (refreshToken: string) => {
  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/refresh-token`;

  return request({ url, method: RequestMethod.POST, body: { refreshToken } });
};

export const useRequireAuthTokens = ({ refreshToken }: { refreshToken: string }) => {
  const queryClient = useQueryClient();
  return useGenericMutation<AuthTokenResponse>(
    [useGetTokenQueryKey],
    async () => requireRefreshedToken(refreshToken),
    {
      retry: 3,
      onSuccess: (data) => {
        if (data) queryClient.setQueryData([useGetTokenQueryKey], data);
      },
    },
    true,
    true
  );
};
